import { useEffect, useLayoutEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { esDNIValido } from "../utils/helpers/validacion.helpers";
import { setCurrentRefreshToken, setCurrentJwt } from "../utils/helpers/jwt.helpers";
import { useAuthContext } from "../context/auth";

import { getFamiliar } from "../services/serviceFamiliar";
import { login, fromTokenToUsuario } from "../services/auth.service";

import Contenedor from '../components/generalStructure/Contenedor/Contenedor';

const Ingreso = () => {

    const navigate = useNavigate();
    const { afiliado, setAfiliado } = useAuthContext(); 

    const [dni, setDni] = useState("");
    const [fechaNacimiento, setFechaNacimiento] = useState("");

    useLayoutEffect(() => {
        if(afiliado && Object.keys(afiliado).length > 0 && afiliado.dni) {
            navigate('/Home', { replace: true });
        }
    }, [afiliado, navigate])


    const buscarAfiliado = () => {
        if(!fechaNacimiento || !fechaNacimiento.length) {
            
            toast.info("Debe seleccionar una fecha de nacimiento.");

        } else if(esDNIValido(dni)){

            login(dni, fechaNacimiento)
                .then(async (authResponse) => {

                    if (authResponse.message) {
                        toast.error(authResponse.message);
                        return;
                    }

                    setCurrentJwt(authResponse.token);
                    setCurrentRefreshToken(authResponse.refreshToken);
                    const afi = await fromTokenToUsuario(authResponse.token);

                    // console.log("afi", afi);
                    // console.log("authResponse", authResponse);

                    if(!Object.keys(afi).length) {
                        throw new Error("Hubo un problema al intentar obtener los datos del usuario");
                    }

                    afi.nombreCompleto = afi.apellido + ", " + afi.nombre;

                    setAfiliado(afi);
                    getFamiliar(dni).then((familiares) => {
                                    
                            console.log("familiares", familiares);

                            setAfiliado(stateAnterior => ({
                                ...stateAnterior,
                                "grupoFamiliar": familiares
                            }));
                        }
                    );
                })
                .catch(err => toast.error(err.message));
        }
    };

    return (
        <Container className="pt-3">
            <Contenedor titulo="SOLICITUD DE TURNOS PARA ASISTENCIA A CENTROS RECREATIVOS">
            <form onSubmit={(e) => {
                    e.preventDefault();
                    buscarAfiliado();
                }}>
                Ingrese su DNI (Debe ser del titular)

                <input
                    type="number"
                    className="form-control form-control-sm mt-2 mb-3 text-center sin-flechas"
                    onChange={e=>setDni(e.target.value)}
                    value={dni}
                />

                Ingrese su fecha de nacimiento

                <input
                    type="date"
                    className="form-control form-control-sm mt-2 mb-3 text-center"
                    onChange={e=>setFechaNacimiento(e.target.value)}
                    pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
                    value={fechaNacimiento}
                    min="1900-01-01"
                    // max="today"
                    required
                />

                <div
                    className="d-grid gap-2"
                >
                    <Button 
                        type="submit"
                        size="sm"
                        variant="success"
                        className="mt-2"
                       
                    >
                        Ingresar
                    </Button>
                </div>
                </form>
            </Contenedor>
        </Container>
    )
};
  
// export async function getServerSideProps(context) {
//     const { afiliado } = useAuthContext(); 

//     if(afiliado && Object.keys(afiliado).length > 0) {
//         router.push('/Home');
//     }
//     // return {
//     //   props: {}, // will be passed to the page component as props
//     // }
// }

export default Ingreso;